<template>
  <section class="positioner">
    <blue-box
      v-if="angleInfoState.visible"
      :show-border="true"
      :style="getStyle"
    >
      {{ $t(angleInfoState.text) + ' ' + angleInfoState.value }}°
    </blue-box>
  </section>
</template>

<script lang="ts">
import { BlueBox } from '@powerplay/core-minigames-ui-ssm'

import { defineComponent } from 'vue'
import { angleInfoState } from '@/stores'

export default defineComponent({
  name: 'AngleInfo',
  components: {
    BlueBox
  },
  data() {

    return {
      angleInfoState: angleInfoState()
    }

  },
  computed: {
    getStyle() {

      return {
        width: '500px',
        height: '70px'
      }

    }
  }
})

</script>

<style lang='less' scoped>
.positioner {
  left: 50%;
  position: absolute;
  top: 12%;

  .blue-box {
    margin-top: 4%;
    text-shadow: 0.6px 0.8px 0.9px rgb(0 0 0 / 71%);
    font-family: Nunito Sans;
    font-size: 48px;
    font-weight: 600;
    letter-spacing: normal;
    color: #fff;
    text-shadow: 0.6px 0.8px 0.9px rgba(0, 0, 0, 0.71);
    padding-top: 2px;
  }
}
</style>
